import React from 'react';
import siteConfig from '../config/siteConfig';
import '../style/handoverBanner.scss';
import { useTranslation } from 'react-i18next';

/**
 * HandoverBanner Component
 * 
 * Displays a marquee-style banner above the main header to inform users
 * about the platform handover and temporary service suspensions.
 * 
 * Visibility is controlled by the siteConfig.showHandoverBanner flag.
 */
const HandoverBanner = () => {
  const { t } = useTranslation();

  // Don't render if banner is disabled in config
  if (!siteConfig.showHandoverBanner) {
    return null;
  }

  const bannerText = t('handoverBannerText', siteConfig.bannerTextFallback);

  return (
    <div className="handover-banner">
      <div className="handover-banner__content">
        <div className="handover-banner__marquee">
          <div className="handover-banner__text">
            <span>{bannerText}</span>
            <span className="handover-banner__separator">•••</span>
            <span>{bannerText}</span>
            <span className="handover-banner__separator">•••</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HandoverBanner;
